import { toRem, baseVariables } from '@marriott/mi-ui-library';
import styled from 'styled-components';
import { constants } from '../../modules/utils/constants/constants';

interface CardCarouselContainerProps {
  cardType: string;
  styleclass?: string;
}

export const StyledCardCarousel = styled.div<CardCarouselContainerProps>`
  padding: ${props => (props.cardType === 'cardlayered' ? `${toRem(40)} 0 ${toRem(20)}` : `${toRem(20)} 0 0 0`)};
  background: ${props => props.cardType === 'propertydetails' && ''};

  @media ${baseVariables.mediaQuery.lg} {
    padding: ${props =>
      props.cardType === 'cardlayered'
        ? `${toRem(86)} 0 ${toRem(40)}`
        : props.cardType === 'editorialfeature'
        ? `0 0 ${toRem(40)}`
        : `${toRem(40)} 0 0 0`};
  }
  @media ${baseVariables.mediaQuery.xl} {
    padding: ${props =>
      props.cardType === 'cardlayered'
        ? `${toRem(80)} 0 ${toRem(40)}`
        : props.cardType === 'editorialfeature'
        ? `0 0 ${toRem(28)}`
        : `${toRem(40)} 0 0 0`};
  }

  .glide .controls_wrapper {
    position: relative;
    bottom: 0;
    padding: 0;
    text-align: -webkit-center;
  }

  .glide {
    position: relative;
  }

  .carousal_header .t-overline-normal {
    color: ${baseVariables.color.merch50};
  }

  .t-title-s {
    color: ${props => props.cardType === 'propertydetails' && 'unset'};
  }

  .home-page-container {
    position: relative;
  }
  .carousal_header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .carousal_header--cta {
      display: flex;
      align-items: flex-end;
    }
  }
  .glide {
    &__track {
      overflow: hidden;
      padding-top: ${props => (props?.cardType === 'propertydetails' ? `${toRem(16)} !important` : `${toRem(24)}`)};
      .glide__slides_authoring {
        width: 100% !important;
        flex-wrap: wrap;
      }
      .glide__slides {
        margin: ${props => (props?.cardType === 'cardvertical' ? `${toRem(-8)} 0 0 ${toRem(-8)}` : 0)};
        .aem-container {
          padding: 0;
        }
      }
    }
    .center-align {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .card-layered-slides {
    column-gap: ${toRem(16)};
  }

  .glide--swipeable {
    cursor: default;
  }

  .glide__bullet {
    color: ${props => (props.cardType === 'propertydetails' ? 'initial' : `${baseVariables.color.merch50}`)};
  }

  .editorial-carousal {
    left: unset;
    position: relative;
  }

  .carouselControlType1 div > button {
    &:focus-visible {
      outline: auto;
    }
  }

  .carouselControlType2 {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    flex-wrap: nowrap;
  }

  .carouselControlType2 .glide__arrows:first-of-type {
    margin-right: auto;
    flex: 1 1 auto;
    white-space: nowrap;
  }

  .carouselControlType2 .glide__arrows:last-of-type {
    margin-left: auto;
    flex: 1 1 auto;
    white-space: nowrap;
  }

  .carouselControlType2 [data-glide-el='controls[nav]'] {
    flex: 0 0 auto;
    min-width: 0;
  }

  .carouselControlType2 div > button:focus-visible {
    outline: auto;
  }

  .carouselControlType1 button[class*='-active']::after {
    opacity: 1;
  }

  .carouselControlType1 .left-arrow,
  .carouselControlType1 .left-arrow:hover,
  .carouselControlType1 .right-arrow,
  .carouselControlType1 .right-arrow:hover {
    span {
      &::before {
        opacity: 0.54;
      }
    }
  }
  .carouselControlType2 .left-arrow,
  .carouselControlType2 .right-arrow {
    &::before {
      white-space: nowrap;
    }
    &::after {
      white-space: nowrap;
    }
  }

  .card-vertical {
    background-color: ${baseVariables.color.merch50};
  }

  @media ${baseVariables.mediaQuery.allTablets && baseVariables.mediaQuery.largeDesktop} {
    .home-page-container {
      position: relative;
    }

    .glide .controls_wrapper {
      margin-left: ${toRem(368)};
      text-align: none;
      bottom: ${toRem(32)};
    }

    .editorial-carousal {
      padding-left: ${toRem(376)};
    }
  }

  .glide__arrows > .left-arrow:is(${constants.RTL_LANG_LIST}) {
    right: ${toRem(-20)} !important;
    left: unset !important;
  }
  .glide__arrows > .right-arrow:is(${constants.RTL_LANG_LIST}) {
    left: ${toRem(-20)} !important;
  }


  &:is(${constants.RTL_LANG_LIST}) {
    // .carouselControlType1 div > button {
      // background-color: ${baseVariables.color.merch50};
      // &:focus-visible {
        // outline: auto;
      // }
    // }

    .carouselControlType1 .right-arrow {
      right: -1.25rem;
      left: unset;
    }

    .carouselControlType1 .left-arrow {
      left: -1.25rem;
      right: unset;
    }
  }

   &:is(${constants.RTL_LANG_LIST}) {
    // .m-link-tertiary-button{
      // margin-left: ${toRem(27)} !important;
    // }

    // .m-link-tertiary-button::after {
      // transform: rotate(-90deg) translate(-3px, -5px) !important;
    // }

    .editorial-carousal {
      // left: unset;
      // position: relative;

      // @media ${baseVariables.mediaQuery.allTablets && baseVariables.mediaQuery.largeDesktop} {
        // padding-right: ${toRem(376)};
        // padding-left: 0;
      // }

      .glide__arrows
      {
        .icon-arrow-left {
          &::before{
            content: "\\e922";
          }
        }
        .icon-arrow-right {
          &::before{
            content: "\\e921";
          }
        }

        .glide__arrow--left {
          margin-left: ${toRem(24)};
          margin-right: 0;
        }

        .glide__arrow--right {
          margin-right: ${toRem(24)};
          margin-left: 0;
        }
      }
    }
  

    // .list-unstyled {
      // list-style-type: none;
    // }

    // .glide__slides,
    // .glide__track {
      // overflow: hidden;
      // .chevronContainer {
        // margin: 0 auto;
        // @media ${baseVariables.mediaQuery.md} {
          // margin: 0;
        // }
      // }
    // }

    // .card-texts {
      // text-align: right;
    // }

    // .icon-arrow-right-external  { 
        // &::before {         
          // transform: rotate(180deg) !important;
          // transition: 0.15s all ease-in;
          // left: 0.5rem;
          // right: unset !important;
        // }

        // &:hover {
          // &::before {
            // transform: rotate(225deg) !important;
            // transition: 0.15s all ease-in;
          // }
        // }
    // }
  // }

`;
